import { date as commonDate } from '@finley-technologies/common';
import { DataLake, Util } from '@finley-technologies/finley-types';

import { FinleyAiDrawerDisplayMode } from '~/packages/finleyAi/ui/FinleyAiAthenaSqlGenerationDrawerContainer';

export const previousReportingDateColumnName = 'previousReportingDate' as const;
export const previousValueColumnName = 'previousValue' as const;
export const currentReportingDateColumnName = 'currentReportingDate' as const;
export const currentValueColumnName = 'currentValue' as const;
export const finleyreceivableidColumnName = 'finleyreceivableid' as const;

export const cdqDetailTableHeaders = [
  finleyreceivableidColumnName,
  previousReportingDateColumnName,
  previousValueColumnName,
  currentReportingDateColumnName,
  currentValueColumnName,
];

export const getReportingDatesString = ({
  firstReportingDate,
  lastReportingDate,
}: {
  firstReportingDate: Util.FullDateStr | undefined;
  lastReportingDate: Util.FullDateStr | undefined;
}) => {
  if (!firstReportingDate) {
    return lastReportingDate
      ? `Reporting Date: ${commonDate.fullDateStrToHumanDateString(
          lastReportingDate,
        )}`
      : '-';
  }
  return lastReportingDate
    ? `Reporting Dates: ${commonDate.fullDateStrToHumanDateString(
        firstReportingDate,
      )} - ${commonDate.fullDateStrToHumanDateString(lastReportingDate)}`
    : `Reporting Date: ${commonDate.fullDateStrToHumanDateString(
        firstReportingDate,
      )}`;
};

export type CollateralDataQualityViewMode = 'overview' | 'detail';
export type CollateralDataQualityResults = {
  cdqConfigName: string;
  queryResults: DataLake.AthenaQueryItemData[];
};

export const collateralDataQualitySortModes = ['ascName', 'descName'] as const;
export type CollateralDataQualitySortMode = typeof collateralDataQualitySortModes[number];
export const collateralDataQualitySortModeOptions: {
  value: CollateralDataQualitySortMode;
  label: string;
}[] = [
  {
    value: 'ascName',
    label: 'Name (ascending)',
  },
  { value: 'descName', label: 'Name (descending)' },
];

export type AddCdqDrawerDisplayMode = FinleyAiDrawerDisplayMode | 'manual';

export const placeholderSQLString =
  'SELECT\n-- List all the required fields\nFROM\n-- Specify the table(s) from which the columns are being retrieved.\nWHERE\n-- Apply any conditions to filter the results.';

export const getQueryTestResultMissingHeaders = ({
  queryResults,
}: {
  queryResults: DataLake.AthenaQueryItemData[];
}) => {
  const missingHeaders: string[] = [];
  const queryResultHeaders = Object.keys(queryResults[0]);

  cdqDetailTableHeaders.forEach((requiredHeader) => {
    if (!queryResultHeaders.includes(requiredHeader)) {
      missingHeaders.push(requiredHeader);
    }
  });

  return missingHeaders;
};

// eslint-disable-next-line no-template-curly-in-string
const rawPromptTemplateVariable = '${rawPrompt}'; // This is the template variable supported by sqlGeneration

export const cdqRawPromptTemplateString = `I want to return records specifically where "${rawPromptTemplateVariable}". Please check for this by looking at the most 2 recent available reporting dates for each record, and testing those two values against each other. Only return records where "${rawPromptTemplateVariable}".

The query must return the following 5 column names: currentReportingDate (the most recent reporting date), currentValue (the value of the most recent reporting date), previousReportingDate (the second most recent reporting date), previousValue (the value of the second most recent reporting date), finleyreceivableid.

Use LAG and partition by in your query. please order by currentReportingDate`;

export const cdqPromptSuggestions: string[] = [
  'Exposure decreases by more than 100%',
  'Whether the receivable is eligible changes',
];
